import { formatInTimeZone, zonedTimeToUtc } from "date-fns-tz";

type DateInput = Date | number | string;

const isYMD = (s: string) => /^\d{4}-\d{2}-\d{2}$/.test(s);

export function formatYMDInTZ(
  input: DateInput,
  timeZone = "America/Sao_Paulo",
): string {
  let date: Date;

  if (typeof input === "string" && isYMD(input)) {
    date = zonedTimeToUtc(`${input}T00:00:00`, timeZone);
  } else if (input instanceof Date) {
    date = input;
  } else {
    date = new Date(input);
  }

  if (isNaN(date.getTime())) {
    throw new Error("Data inválida");
  }

  return formatInTimeZone(date, timeZone, "yyyy-MM-dd");
}
